import {request} from '@/utils/request2.js'

export function topSearchFor36kr(data) {
    return request({
        url: '/36kr',
        method: 'get',
        data: data
    })
}

export function topSearchFor51cto(data) {
    return request({
        url: '/51cto',
        method: 'get',
        data: data
    })
}

export function topSearchFor52pojie(data) {
    return request({
        url: '/52pojie',
        method: 'get',
        data: data
    })
}

export function topSearchForAcfun(data) {
    return request({
        url: '/acfun',
        method: 'get',
        data: data
    })
}

export function topSearchForBaidu(data) {
    return request({
        url: '/baidu',
        method: 'get',
        data: data
    })
}

export function topSearchForBilibili(data) {
    return request({
        url: '/bilibili',
        method: 'get',
        data: data
    })
}

export function topSearchForCoolapk(data) {
    return request({
        url: '/coolapk',
        method: 'get',
        data: data
    })
}

export function topSearchForCsdn(data) {
    return request({
        url: '/csdn',
        method: 'get',
        data: data
    })
}

export function topSearchForDgtle(data) {
    return request({
        url: '/dgtle',
        method: 'get',
        data: data
    })
}

export function topSearchForDoubanGroup(data) {
    return request({
        url: '/douban-group',
        method: 'get',
        data: data
    })
}

export function topSearchForDoubanMovie(data) {
    return request({
        url: '/douban-movie',
        method: 'get',
        data: data
    })
}

export function topSearchForDouyin(data) {
    return request({
        url: '/douyin',
        method: 'get',
        data: data
    })
}

export function topSearchForEarthquake(data) {
    return request({
        url: '/earthquake',
        method: 'get',
        data: data
    })
}

export function topSearchForGeekpark(data) {
    return request({
        url: '/geekpark',
        method: 'get',
        data: data
    })
}

export function topSearchForGenshin(data) {
    return request({
        url: '/genshin',
        method: 'get',
        data: data
    })
}

export function topSearchForGithub(data) {
    return request({
        url: '/github',
        method: 'get',
        data: data
    })
}

export function topSearchForGuokr(data) {
    return request({
        url: '/guokr',
        method: 'get',
        data: data
    })
}

export function topSearchForHackernews(data) {
    return request({
        url: '/hackernews',
        method: 'get',
        data: data
    })
}

export function topSearchForHellogithub(data) {
    return request({
        url: '/hellogithub',
        method: 'get',
        data: data
    })
}

export function topSearchForHistory(data) {
    return request({
        url: '/history',
        method: 'get',
        data: data
    })
}

export function topSearchForHonkai(data) {
    return request({
        url: '/honkai',
        method: 'get',
        data: data
    })
}

export function topSearchForHostloc(data) {
    return request({
        url: '/hostloc',
        method: 'get',
        data: data
    })
}

export function topSearchForHupu(data) {
    return request({
        url: '/hupu',
        method: 'get',
        data: data
    })
}

export function topSearchForHuxiu(data) {
    return request({
        url: '/huxiu',
        method: 'get',
        data: data
    })
}

export function topSearchForIfanr(data) {
    return request({
        url: '/ifanr',
        method: 'get',
        data: data
    })
}

export function topSearchForIthomeXijiayi(data) {
    return request({
        url: '/ithome-xijiayi',
        method: 'get',
        data: data
    })
}

export function topSearchForIthome(data) {
    return request({
        url: '/ithome',
        method: 'get',
        data: data
    })
}

export function topSearchForJianshu(data) {
    return request({
        url: '/jianshu',
        method: 'get',
        data: data
    })
}

export function topSearchForJuejin(data) {
    return request({
        url: '/juejin',
        method: 'get',
        data: data
    })
}

export function topSearchForKuaishou(data) {
    return request({
        url: '/kuaishou',
        method: 'get',
        data: data
    })
}

export function topSearchForLinuxdo(data) {
    return request({
        url: '/linuxdo',
        method: 'get',
        data: data
    })
}

export function topSearchForLol(data) {
    return request({
        url: '/lol',
        method: 'get',
        data: data
    })
}

export function topSearchForMiyoushe(data) {
    return request({
        url: '/miyoushe',
        method: 'get',
        data: data
    })
}

export function topSearchForNeteaseNews(data) {
    return request({
        url: '/netease-news',
        method: 'get',
        data: data
    })
}

export function topSearchForNewsmth(data) {
    return request({
        url: '/newsmth',
        method: 'get',
        data: data
    })
}

export function topSearchForNgabbs(data) {
    return request({
        url: '/ngabbs',
        method: 'get',
        data: data
    })
}

export function topSearchForNodeseek(data) {
    return request({
        url: '/nodeseek',
        method: 'get',
        data: data
    })
}

export function topSearchForNytimes(data) {
    return request({
        url: '/nytimes',
        method: 'get',
        data: data
    })
}

export function topSearchForProducthunt(data) {
    return request({
        url: '/producthunt',
        method: 'get',
        data: data
    })
}

export function topSearchForQqNews(data) {
    return request({
        url: '/qq-news',
        method: 'get',
        data: data
    })
}

export function topSearchForSinaNews(data) {
    return request({
        url: '/sina-news',
        method: 'get',
        data: data
    })
}

export function topSearchForSina(data) {
    return request({
        url: '/sina',
        method: 'get',
        data: data
    })
}

export function topSearchForSmzdm(data) {
    return request({
        url: '/smzdm',
        method: 'get',
        data: data
    })
}

export function topSearchForSspai(data) {
    return request({
        url: '/sspai',
        method: 'get',
        data: data
    })
}

export function topSearchForStarrail(data) {
    return request({
        url: '/starrail',
        method: 'get',
        data: data
    })
}

export function topSearchForThepaper(data) {
    return request({
        url: '/thepaper',
        method: 'get',
        data: data
    })
}

export function topSearchForTieba(data) {
    return request({
        url: '/tieba',
        method: 'get',
        data: data
    })
}

export function topSearchForToutiao(data) {
    return request({
        url: '/toutiao',
        method: 'get',
        data: data
    })
}

export function topSearchForV2ex(data) {
    return request({
        url: '/v2ex',
        method: 'get',
        data: data
    })
}

export function topSearchForWeatheralarm(data) {
    return request({
        url: '/weatheralarm',
        method: 'get',
        data: data
    })
}

export function topSearchForWeibo(data) {
    return request({
        url: '/weibo',
        method: 'get',
        data: data
    })
}

export function topSearchForWeread(data) {
    return request({
        url: '/weread',
        method: 'get',
        data: data
    })
}

export function topSearchForXueqiu(data) {
    return request({
        url: '/xueqiu',
        method: 'get',
        data: data
    })
}

export function topSearchForYystv(data) {
    return request({
        url: '/yystv',
        method: 'get',
        data: data
    })
}

export function topSearchForZhihuDaily(data) {
    return request({
        url: '/zhihu-daily',
        method: 'get',
        data: data
    })
}

export function topSearchForZhihu(data) {
    return request({
        url: '/zhihu',
        method: 'get',
        data: data
    })
}
